import clsx from 'clsx';
import { AlertCircle } from 'react-feather';

interface ErrorTextProps {
  message: string;
  className?: string;
}

export default function ErrorText({ message, className }: ErrorTextProps) {
  return (
    <div className={clsx('flex text-red-500 items-center', className)}>
      <AlertCircle />
      <span className="text-sm ml-1">{message}</span>
    </div>
  );
}
